module.exports = __webpack_public_path__ + "img/favoriteOn.50db9cfd.svg";